import React,{useState,useContext, useEffect} from 'react'
import mqtt from "precompiled-mqtt";

const MqttContext = React.createContext();
const mqttOptions = {
    // Clean session
    clean: true,
    protocol: "wss",
    port: process.env.REACT_APP_MQ_PORT,
    path: "/mqtt",
    //connectTimeout: 4000,
    // Authentication
    clientId: Math.floor(Math.random() * 100),
    username: process.env.REACT_APP_MQ_USERNAME,
    password: process.env.REACT_APP_MQ_PASSWORD,
}
const mqURL = process.env.REACT_APP_MQ_URL;

let _appName = "n-"+localStorage.getItem("portalId");

export const useMqtt = () => {
    return useContext(MqttContext);
}


export const MqttProvider = (props) =>{
    const [mqClient,setMQClient] = useState(null)
    const [newMessage,setNewMessage] = useState(null);

    const connectMqtt = () =>{
        console.log(mqttOptions);
        let client  = mqtt.connect(mqURL,mqttOptions);
        setMQClient(client);
        console.log("mqClientReady");
    }
    useEffect(()=>{
        connectMqtt();
    },[])

    
    
    useEffect(()=>{
        if(mqClient !== null){
            mqClient.on('message', function (topic, message) {
                // message is Buffer
                let m = message.toString();
                let messageObj = JSON.parse(m);
                //console.log("message received for "+topic);
                //console.log("Message received");
                //console.log("message is ",m)
                //console.log(messageObj);

                let _newMessage = {
                    topic:topic,
                    event:messageObj.event,
                    data:messageObj.token,
                }
                setNewMessage(_newMessage)
                //client.end()
            });
            mqClient.subscribe(_appName)
        }
    },[mqClient])
    


    const publishMessage = (message) =>{
        //console.log("publishing message");
        //mqClient.publish(topic+"command",'{"Site_ID":"Area1","Device_ID":"STPAQTT11230001","T":"1205.mp3","T_PT":0,"H_PT":0,"TS":true,"HS":false}');
        //console.log("device Message","Hello Web mocket")
        mqClient.publish(_appName, JSON.stringify(message));
        //console.log("topic",_appName)
        //console.log("message",message)
        //console.log("message published");
    }


    return (
        <MqttContext.Provider value={{mqClient,publishMessage,newMessage}}>
            {mqClient !==null && props.children}
        </MqttContext.Provider>
    )
}